import React from 'react'
import PropTypes from 'prop-types'

import { digObject } from '@domain-group/javascript-utils'

import { DashboardModule, Form } from '@domain-group/suit-theme'

const PublicationSettings = (props) => {
  const { serviceProductForm } = props

  const {
    entityState,
    handlers,
  } = serviceProductForm

  const { rows, columns } = digObject(entityState, 'options.publication.grid', {})

  return (
    <DashboardModule title="Publication Settings">
      <Form padding="large">
        <Form.Row>
          <Form.Field label="Rows">
            <input
              data-value-type="integer"
              name="options.publication.grid.rows"
              type="text"
              value={rows}
              {...handlers}
            />
          </Form.Field>

          <Form.Field label="Columns" marginTop={['large', 0]}>
            <input
              data-value-type="integer"
              name="options.publication.grid.columns"
              type="text"
              value={columns}
              {...handlers}
            />
          </Form.Field>
        </Form.Row>
      </Form>
    </DashboardModule>
  )
}

PublicationSettings.propTypes = {
  serviceProductForm: PropTypes.object.isRequired,
}

export default PublicationSettings
